// RequireAuth — gates the app shell. While the first /api/auth/me probe is in
// flight nothing renders (avoids login flicker on warm sessions). Signed-out
// users are redirected to /login with a returnUrl.

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider.jsx";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }
  return children;
}

/** Gates a route to specific roles; others see a friendly denial. */
export function RequireRole({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user?.role || !roles.includes(user.role)) {
    return (
      <div className="denied">
        <h2>Not available for your role</h2>
        <p>This page requires {roles.join(" / ")} access. Ask your administrator if you believe this is a mistake.</p>
      </div>
    );
  }
  return children;
}
